import { api, StoreKey } from '../../../configs/api';
import { APP_CONFIG, ConfigTokens, CreditApplicationType, getAppHeader, } from '../../../configs/config';
import { ROUTE } from '../../../routes';
import SharedPropsService from '../../../SharedPropsService';
import sharedPropsService from '../../../SharedPropsService';
import { ACTION, } from './types';
import { nextStepId } from '../../../configs/utils';
import AsyncStorage from "@react-native-async-storage/async-storage";
import { requestType } from "../dashboard/actions";
export const enhanceLimit = async (action, _datastore, { instrumentTrack, navigate, network, setDatastore, ...props }) => {
    // set isElevate false in enhance limit case 
    await SharedPropsService.setElevateFlow(false);
    await setDatastore(ROUTE.MANAGE_LIMIT, 'manageLimit', {
        loading: true
    });
    const user = await SharedPropsService.getUser();
    const creditId = user.linkedCredits[0].creditId;
    action.payload.applicationType === CreditApplicationType.CREDIT_MODIFICATION_MARGIN_CALL_AGAINST_SECURITIES ? instrumentTrack("MARGIN_CALL_BUTTON_CLICKED") : instrumentTrack("ENHANCE_LIMIT_BUTTON_CLICKED");
    console.log('applicationType => ', action.payload.applicationType);
    const response = await network.post(`${api.getLimitModificationApplicationForAccountV2}${creditId}/v2`, {
        creditApplicationType: CreditApplicationType.CREDIT_MODIFICATION_AGAINST_SECURITIES,
    }, {
        headers: await getAppHeader(),
        handleFromMF: true,
    });
    if (response?.status === 200) {
        const applicationId = response.data.applicationId;
        await AsyncStorage.setItem("application_id", applicationId);
        user.linkedApplications[0] = response.data;
        await SharedPropsService.setUser(user);
        const routeObj = await nextStepId(response.data.currentStepId);
        // @ts-ignore
        routeObj.params.isFromManageLimit = true;
        await SharedPropsService.setConfig(ConfigTokens.IS_PAN_EDIT_ALLOWED, false);
        await SharedPropsService.setConfig(ConfigTokens.IS_RTA_SWITCH_ENABLED, true);
        await SharedPropsService.setConfig(ConfigTokens.IS_MF_FETCH_BACK_ALLOWED, false);
        await setDatastore(ROUTE.MANAGE_LIMIT, 'manageLimit', {
            loading: false,
            showErrorModal: false,
            counter: Math.random(),
        });
        await navigate(ROUTE.MANAGE_LIMIT_LANDING);
    }
    else if (response?.response?.status === 400) {
        const { voltErrorCode } = response?.response?.data;
        const header = response?.response?.data?.header || 'Verification failed!';
        const message = response?.response?.data?.message || 'Something went wrong';
        if (voltErrorCode === 'BAD_REQUEST_POLICY_VIOLATION') {
            await setDatastore(ROUTE.MANAGE_LIMIT, 'manageLimit', {
                showErrorModal: true,
                loading: false,
                header,
                message,
                counter: Math.random(),
            });
        }
        else {
            await setDatastore(ROUTE.MANAGE_LIMIT, 'manageLimit', {
                showErrorModal: true,
                loading: false,
                header,
                message,
                counter: Math.random(),
            });
        }
    }
    else {
        await setDatastore(ROUTE.MANAGE_LIMIT, 'manageLimit', {
            showErrorModal: true,
            loading: false,
            header: 'Verification failed!',
            message: response?.response?.data?.message || 'Something went wrong',
            counter: Math.random(),
        });
    }
};
export const closeErrorModal = async (action, _datastore, { navigate, setDatastore }) => {
    await setDatastore(ROUTE.MANAGE_LIMIT, 'manageLimit', {
        showErrorModal: false,
        loading: false,
        counter: Math.random(),
    });
};
export const getURL = async (action, _datastore, { setDatastore, network, showPopup, instrumentTrack }) => {
    instrumentTrack('EMAIL_HOLDING_STATEMENT_BUTTON_CLICKED');
    await setDatastore(action.routeId, 'continue', {
        loading: true,
    });
    const user = await sharedPropsService.getUser();
    const accountId = user.linkedBorrowerAccounts[0].accountId;
    const response = await network.get(`${api.pdfHoldingStatement}${accountId}`, {
        headers: await getAppHeader(),
    });
    if (response.status === 200) {
        await setDatastore(action.routeId, 'continue', {
            loading: false,
        });
        showPopup({
            id: 'bt_manageLimit_continue',
            autoTriggerTimerInMilliseconds: APP_CONFIG.MODAL_TRIGGER_TIMEOUT,
            type: 'SUCCESS',
            title: 'Email sent successfully',
            subTitle: 'Account holding details have been sent to your email address.',
            ctaLabel: 'Continue',
            ctaAction: {
                type: ACTION.MAIL_POPUP,
                routeId: ROUTE.MANAGE_LIMIT,
                payload: {},
            },
            primary: false,
        });
    }
    await setDatastore(action.routeId, 'continue', {
        loading: false,
    });
};
export const navigation = async (action, _datastore, { navigate, setDatastore, showPopup, asyncStorage, instrumentTrack }) => {
    console.warn("*** navigationAction props ***", action);
    // @ts-ignore
    const routeId = action.payload.routeId;
    if (routeId === 'DASHBOARD') {
        await navigate(routeId, {
            cacheManageLimitConfig: true,
            cacheCreditData: true,
            cachePendingCreditRequestByCreditId: true,
            // cacheUserContext: true
        });
    }
    else {
        await navigate(routeId);
    }
};
export const oldNavigation = async (action, _datastore, { navigate, setDatastore, showPopup, asyncStorage, instrumentTrack }) => {
    if (action.payload.value === 0) {
        await navigate(ROUTE.DASHBOARD);
    }
    if (action.payload.value === 1) {
        await navigate(ROUTE.TRANSACTIONS, {
            isFromRejectedWithdrawal: false
        });
        await setDatastore(ROUTE.TRANSACTIONS, "TransactionScreen", {
            isFromRejectedWithdrawal: false
        });
    }
};
export const goBack = async (action, _datastore, { navigate, goBack, network, setDatastore }) => {
    const creditAmount = action?.payload?.creditAmount;
    const fundAmount = action?.payload?.fundAmount;
    const requestOptions = {
        method: 'GET',
        headers: await getAppHeader(),
    };
    await setDatastore(ROUTE.MANAGE_LIMIT, 'manageLimit', {
        showCamsLoader: true,
        showNavNextLoader: true,
    });
    const user = await SharedPropsService.getUser();
    const creditResponse = await network
        .get(`${api.getCollateral}${user.linkedCredits[0].creditId}`, requestOptions);
    await setDatastore(ROUTE.MANAGE_LIMIT, 'manageLimit', {
        showCamsLoader: false
    });
    if (creditResponse.status === 200) {
        const tempData = creditResponse.data;
        await SharedPropsService.setPortfolioData(creditResponse.data);
        await navigate(ROUTE.VIEW_PORTFOLIO_DETAIL, { tempData: tempData, creditAmount: creditAmount, fundAmount: fundAmount });
    }
};
export const increaseLimitAction = async (action, _datastore, { navigate, goBack }) => {
    navigate(ROUTE.MANAGE_LIMIT_LANDING);
};
export const mailPop = async (action, _datastore, { navigate, goBack }) => {
    goBack();
};
export const pendingLimitAction = async (action, _datastore, { navigate }) => {
    console.warn("**** pendingLimitAction Action Triggered ****", action);
    const routeId = action?.routeId;
    if (action.payload.type === requestType.RENEWAL_REQUEST) {
        await navigate(ROUTE.LOAN_RENEWAL_STATUS_PAGE, {
            routeId: ROUTE.MANAGE_LIMIT
        });
    }
    else if (action.payload.type === requestType.TRANSACTION_STATUS) {
        await navigate(ROUTE.TRANSACTIONS);
    }
    else {
        await navigate(ROUTE.PRE_DASHBOARD_SCREEN, {
            fromRouteId: "ManageLimit"
        });
    }
};
export const needHelp = async (action, _datastore, { navigate }) => {
    await navigate(ROUTE.CONTACT_US_CARD);
};
export const renewNowAction = async (action, _datastore, { navigate }) => {
    console.warn('**** renewNowAction ACTION TRIGGERRED ****');
    const actualLoanAmount = action?.payload?.actualLoanAmount;
    const loanExpiryDays = action?.payload?.loanExpiryDays;
    const isLoanExpired = action?.payload?.isLoanExpired;
    if (isLoanExpired === true) {
        await sharedPropsService.setIsRenewalAfterExpiry(true);
    }
    await navigate(ROUTE.LOAN_RENEWAL_LANDING_PAGE, {
        actualLoanAmount: actualLoanAmount,
        loanExpiryDays: loanExpiryDays
    });
};
export const loanRenewalExpiredRepayment = async (action, _datastore, { navigateWithClear }) => {
    console.warn('**** loanRenewalExpiredRepayment ACTION TRIGGERRED ****');
    //set the flag to true
    await sharedPropsService.setIsRepaymentAfterExpiry(true);
    await navigateWithClear(ROUTE.REPAYMENT);
};
export const reOpenLoanAccount = async (action, _datastore, { navigateWithClear, network }) => {
    console.warn('**** loanRenewalExpiredRepayment ACTION TRIGGERRED ****');
    //set the flag to true
    const user = await sharedPropsService.getUser();
    const creditId = user?.linkedCredits[0]?.creditId;
    const reopenAccountResponse = await network.post(`${api.reopenAccount}${creditId}`, {}, {
        headers: await getAppHeader()
    });
    if (reopenAccountResponse?.status === 200) {
        await AsyncStorage.removeItem(StoreKey.APPLICATION_ID);
        await navigateWithClear(ROUTE.SPLASH_SCREEN);
    }
};
export const OpenContactUS = async (action, _datastore, { navigate, instrumentTrack }) => {
    await navigate(ROUTE.CONTACT_US);
};
export const goBackAction = async (action, _datastore, { navigate, goBack }) => {
    await navigate(ROUTE.DASHBOARD);
};
